import { applyTheme, readTheme } from './app/theme';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n';
import './styles.css';
import './features/teacher/teacher.css';
import './experience.css';
import './design/tokens.css';
import './design/components.css';
import './design/motion.css';
import { ErrorBoundary } from './shared/ErrorBoundary';

applyTheme(readTheme());

const root = document.getElementById('root');
if (!root) throw new Error('Application root is missing.');

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
